import { StyleSheet } from 'react-native';
import { Colors } from '@qnpm/q-theme';
import {DeviceInfo} from 'qunar-react-native'
import isLowAdr from '../../../constant/isLowAdr';

const IOS_STATUS_BAR_HEIGHT = DeviceInfo.isIphoneX ? 44 : 20;
const { isWeb, isIOS, isAndroid } = DeviceInfo;
const { scenes: { baseColor } } = Colors;
let immersiveOffset = 0;

if (isWeb) {
    const hytiveReg = "(^|\\s)(qunar[^\\/]+)\\/([\\d\\.]+)";
    const isQunar = !!(navigator.userAgent.toLowerCase().match(hytiveReg));
    if (isQunar) {
        if (isIOS) {
            // eslint-disable-next-line no-undef
            const nativeRes = __getSystemInfo;
            try {
                const info = JSON.parse(nativeRes);
                immersiveOffset = info?.immersiveInfo?.immersiveOffset;
            } catch (e) {
                console.log(e);
            }           
        } else if (isAndroid) {
            // eslint-disable-next-line no-undef
            const nativeRes = WebViewJavascriptBridgeNative.__getSystemInfo();
            try {
                const info = JSON.parse(nativeRes);
                immersiveOffset = info?.immersiveInfo?.immersiveOffset;
            } catch (e) {
                console.log(e);
            } 
        }       
    }
}

export default StyleSheet.create({
    statusBar:{
        height:DeviceInfo.isAndroid || DeviceInfo.isNotRn ? DeviceInfo.immersiveInfo.immersiveOffset : IOS_STATUS_BAR_HEIGHT,
        backgroundColor: isLowAdr ? 'black' : baseColor.background2
    },
    statusBar2: {
        height: immersiveOffset,
        backgroundColor: isLowAdr ? 'black' : baseColor.background2
    },
    header: {
        flexDirection: 'row',
        // flex: 1,
        height: 44,
        marginRight:15,
        backgroundColor: baseColor.background2,
    },
    backBtnWrapper: {
        width: 74,
        height: 44,
        justifyContent: 'center'
    },
    backBtn: {
        marginLeft: 20,
        fontFamily: 'cmn_order_rn',
        fontSize: 20,
        color: baseColor.text1
    },
    orderSearchBtnWrapper: {
        width: 74,
        height: 44,
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    orderSearchBtn: {
        width: 65,
        marginRight: 5,
        textAlign: 'right',
        fontSize: 15,
        color: baseColor.text1
    },
    titleWrapper: {
        flex: 1,
        flexDirection: 'row'
    },
    title: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    titleText: {
        fontSize: 18,
        color: baseColor.text1
    },
    arrow: {
        fontFamily: 'cmn_order_rn',
        fontSize: 18,
        color: baseColor.text1,
        marginLeft: 2
    }
});
